import secureLocalStorage from "react-secure-storage";

// A Stock Administrator can switch to a branch. The stored profile then reads
// as that branch's Read-Write user, so every page behaves as it does for the
// branch, and the server treats each request the same way (it checks the real
// user's right; see ACTING_BRANCH_HEADER).

const readStored = (key) => {
  try {
    return JSON.parse(secureLocalStorage.getItem(key) || "null");
  } catch {
    return null;
  }
};

export const ADMIN_PROFILE_KEY = "profile-before-branch-switch";
export const ACTING_BRANCH_HEADER = "X-Stock-Acting-Branch";

// Name of the location an Administrator has switched to, else null
export const getActingBranch = () => readStored("profile")?.actingBranch || null;

// The Administrator's own profile, kept aside while switched to a branch
const readSignedInProfile = () => readStored(ADMIN_PROFILE_KEY) || readStored("profile");

export const canSwitchBranch = () =>
  readSignedInProfile()?.results?.stock === "Administrator";

// Both reload the app, because pages, the store and API helpers read the
// profile as they load
export const switchToBranch = (location) => {
  const admin = readSignedInProfile();
  secureLocalStorage.setItem(ADMIN_PROFILE_KEY, JSON.stringify(admin));
  secureLocalStorage.setItem(
    "profile",
    JSON.stringify({
      ...admin,
      actingBranch: location,
      results: { ...admin.results, stock: "Read-Write", branch: location },
    }),
  );
  window.location.assign("/stock/");
};

export const stopActingAsBranch = () => {
  const admin = readStored(ADMIN_PROFILE_KEY);
  if (admin) secureLocalStorage.setItem("profile", JSON.stringify(admin));
  secureLocalStorage.removeItem(ADMIN_PROFILE_KEY);
  window.location.assign("/stock/");
};
